const connectObject = (state = false, action)=>{
    if(action.type === "SET_CONNECT_OBJECT"){
        state = action.state
    }
    return state;
}

export default connectObject;